var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-not-found valign-center flex-center"},[_c('span',[_vm._v(_vm._s(_vm.$route.query.msg || "页面不存在"))])])
}
var staticRenderFns = []

export { render, staticRenderFns }